import { Filter } from 'mk/bazaar/product/filter/filterUtils';
import {
    initialState,
    perFilterInitialState,
    perSellerInitialState,
    PerFilterState,
    PerSellerState,
    State,
} from 'mk2/apps/bazaar/containers/HerBazaar/HerBazaar.reducers';
import { hashFilter } from 'mk2/apps/bazaar/helpers/filter';
import { AppState } from 'mk2/reducers';

export const getHerBazaarState = (state: AppState): State => state.containers.bazaar.herBazaar || initialState;

export const getHerBazaarSellerState = (state: AppState, username: string): PerSellerState =>
    getHerBazaarState(state).sellers[username] || perSellerInitialState;

export const getHerBazaarSellerFilterState = (state: AppState, username: string, filter: Filter): PerFilterState =>
    getHerBazaarSellerState(state, username).filters[hashFilter(filter)] || perFilterInitialState;
